module.exports = __webpack_public_path__ + "297d4a56b9de9f19430f7d91f4f440d7.svg";